<app-base-modal [showClose]="showClose">
  <h1 class="title"
    [ngClass]="{ warn: type === 'warn' || type === 'warn-exclamation' || type === 'none' || !type, default: type === 'default', 'order-id': orderId }"
    [innerHTML]="title"></h1>
  <div class="content">
    <div class="container-image" *ngIf="image && !seeRegulamentation">
      <img [src]="image" />
    </div>
    <div *ngIf="orderId" class="order-id-container">
      <p class="order-id">Nº do pedido</p>
      <p class="order-id-value">{{ orderId }}</p>
    </div>
    <p class="msg" [innerHTML]="description"></p>
    <div class="footer-buttons" *ngIf="mainLabel || secondaryLabel">
      <ion-button color="primary" fill="solid" expand="block" class="wrap-text"
        (click)="closeModal('main', null, mainEvent)" *ngIf="mainLabel">
        {{ mainLabel }}
      </ion-button>
      <ion-button [color]="type === 'warn' ? 'primary' : 'dark'" style="margin-top: 0.9em"
        fill="outline" expand="block" (click)="closeModal('secondary', null, secondaryEvent)"
        *ngIf="secondaryLabel">
        {{ secondaryLabel }}
      </ion-button>
    </div>
    <div *ngIf="seeRegulamentation" style="margin-top: -1em">
      <ion-button color="primary" fill="clear" expand="block" (click)="openRegulamentation()"
        class="see-regulamentation">
        Ver regulamento
      </ion-button>
    </div>
  </div>
</app-base-modal>